/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2019-12-09 19:09:57
 * @LastEditors: mrh
 * @LastEditTime: 2022-05-26 18:46:28
 */
import Vue from 'vue'
import axios from "axios"
// 1悦买端 2店长端
const pathType = Vue.prototype.pathType
//300下拉提示搜索
export function suggestSearch(params) {
  return axios.post(`/${pathType == 1 ? "buyer/2_1" : "v30/cs"}/suggestSearch`, params).then((res) => res.data);
}
//300 排行榜开关（杨斯匀）
export function getState(params) {
  return axios.post(`/${pathType == 1 ? "buyer/2_1/invite" : "v30/cs/rank"}/getState`, params).then((res) => res.data);
}
// 300申请开通社区（王冬冬）
export function addCommunity(params) {
  return axios.post(`/${pathType == 1 ? "buyer/2_1" : "v30"}/cs/apply/addCommunity`, params).then((res) => res.data);
}
// 300获取商圈信息（王冬冬）
export function getBusinesscCircleList(params) {
  return axios.post(`/${pathType == 1 ? "buyer/2_1" : "v30"}/cs/getBusinesscCircleList`, params).then((res) => res.data);
}
//310 搜索社区（王冬冬,赵玉龙）
export function searchCsList(params) {
  return axios.post(`/${pathType == 1 ? "buyer/2_1" : "v30"}/cs/searchCsList`, params).then((res) => res.data);
}
// 300 社区店长 获取平安绑卡验证码（王冬冬）
export function getBindingSmsCode(params) {
  return axios.post("/v30/cs/pingan/getBindingSmsCode", params).then((res) => res.data);
}
// 300 社区店长 绑卡鉴权--》回填短信验证码（王冬冬）
export function putBindingSmsCode(params) {
  return axios.post("/v30/cs/pingan/putBindingSmsCode", params).then((res) => res.data);
}
// 300 社区店长 提现--》获取验证码（王冬冬）
export function getWithdrawSmsCode(params) {
  return axios.post("/v30/cs/getWithdrawSmsCode", params).then((res) => res.data);
}
// 300 社区店长 提现--》回填验证码（王冬冬）
export function putWithdrawSmsCode(params) {
  return axios.post("/v30/cs/putWithdrawSmsCode", params).then((res) => res.data);
}
// 300 绑卡1-获取银行代码(王冬冬)
export function getBindingBankClsCodeList(params) {
  return axios.post("/v30/cs/pingan/getBindingBankClsCodeList", params).then((res) => res.data);
}
// 300 绑卡2-获取省份列表(王冬冬)
export function getBindingProvinceList(params) {
  return axios.post("/v30/cs/pingan/getBindingProvinceList", params).then((res) => res.data);
}
// 300 绑卡3/4-获取市、区(市)、县列表(王冬冬)
export function getBindingCityList(params) {
  return axios.post("/v30/cs/pingan/getBindingCityList", params).then((res) => res.data);
}
// 300 绑卡5-获取银行网点列表(王冬冬)
export function getBindingBankInfoList(params) {
  return axios.post("/v30/cs/pingan/getBindingBankInfoList", params).then((res) => res.data);
}
// 300 解绑银行卡公共接口（王冬冬）
export function delCard(params) {
  return axios.post("/v30/cs/pingan/delCard", params).then((res) => res.data);
}
// 270店铺订单详情(高斯凌)
export function orders(params) {
  return axios.post("/buyer/2_1/cs/communityShop_orders", params).then((res) => res.data);
}
// 270店铺订单详情(高斯凌)
export function ordersDetail(params) {
  return axios.post("/buyer/2_1/cs/communityShop_ordersDetail", params).then((res) => res.data);
}
// 270活动规则内容（郭伦）
export function getActivityRuleContent(params) {
  return axios.post("/seller/2_1/getActivityRuleContent", params).then((res) => res.data);
}
// 300 店长获取 待结算列表(王冬冬)
export function tobeSettled(params) {
  return axios.post("/v30/cs/wallet/tobeSettled", params).then((res) => res.data);
}
// 300 店长的个人中心（王冬冬）
export function myShop(params) {
  return axios.post("/v30/cs/shop/myShop", params).then((res) => res.data);
}
// 270升级为正式店长（郭伦）
export function updateToOfficial(params) {
  return axios.post("/buyer/2_1/cs/updateToOfficial", params).then((res) => res.data);
}
// 270物流查询(高斯凌)
export function getOrderExpress(params) {
  return axios.post("/buyer/2_1/cs/getOrderExpress", params).then((res) => res.data);
}
// 300 店长获取已绑银行卡列表（王冬冬）
export function getBindingCardList(params) {
  return axios.post("/v30/cs/pingan/getBindingCardList", params).then((res) => res.data);
}
// 300 获取最小提现值和最大提现值（温子仪，杨斯匀）
export function walletInfo(params) {
  return axios.post("/v30/cs/pingan/getSystemWithdrawValue", params).then((res) => res.data);
}
// 获取我的店铺首页信息
export function getCommunityShopById(params) {
  return axios.post("/buyer/2_1/283/cs/homeIndex", params).then((res) => res.data);
}
// 我的店铺-店内搜索
export function searchProduct(params) {
  return axios.post("/buyer/2_1/cs/searchProduct", params).then((res) => res.data);
}
// 我的店铺-获取热门搜索纪录
export function getHotKeyword(params) {
  return axios.post("/buyer/2_1/getHotKeyword", params).then((res) => res.data);
}
// 我的店铺-获取预告专区list
// export function reservationList(params) {
//     return axios.post('/buyer/2_1/cs/reservation/list', params).then(res => res.data);
// }
// 300扫码提货（高斯凌）
export function scanPickUpGoods(params) {
  return axios.post("/v30/cs/scanPickUpGoods", params).then((res) => res.data);
}
// 300 店长获取金额明细列表(王冬冬)
export function streamList(params) {
  return axios.post("/v30/cs/wallet/streamList", params).then((res) => res.data);
}
// 300 完成订单（高斯凌）
export function confirmReceipt(params) {
  return axios.post("/v30/cs/confirmReceipt", params).then((res) => res.data);
}
// 270申请正式店长条件（郭伦）
export function applyCondition(params) {
  return axios.post("/buyer/2_1/cs/applyCondition", params).then((res) => res.data);
}
// 270获取该社区是否可以申请店长（郭伦）
export function getIsCanApplyOrResult(params) {
  return axios.post("/buyer/2_1/cs/apply/getIsCanApplyOrResult", params).then((res) => res.data);
}
// 270提交申请店长（郭伦）
export function applySubmit(params) {
  return axios.post("/buyer/2_1/cs/apply/submit", params).then((res) => res.data);
}
// 270附近社区（获取社区店列表）(赵玉龙)
export function csList(params) {
  return axios.post("/buyer/2_1/cs/list", params).then((res) => res.data);
}
// 270获取商品详情
export function goodDetail(params) {
  return axios.post("/buyer/2_1/cs/product/detail", params).then((res) => res.data);
}
// 270我的分享商品（王冬冬）
export function shareProduct(params) {
  return axios.post("/buyer/2_1/cs/my/share/product", params).then((res) => res.data);
}
// 270提醒用户取货（高斯凌）
export function pushPickUpUrge(params) {
  return axios.post("/buyer/2_1/cs/pushPickUpUrge", params).then((res) => res.data);
}
// 270获取推荐商品列表
export function recommendProductList(params) {
  return axios.post("/buyer/2_1/cs/factory/recommendProductList", params).then((res) => res.data);
}
// 270获取爆款商品列表
export function reservationList(params) {
  return axios.post("/buyer/2_1/cs/reservation/list", params).then((res) => res.data);
}
// 270获取拼单商品列表
export function collageOrderList(params) {
  return axios.post("/buyer/2_1/cs/collageOrder/list", params).then((res) => res.data);
}
// 270获取厂家直供商品列表
export function directSupplyProduct(params) {
  return axios.post("/buyer/2_1/cs/factory/directSupplyProduct", params).then((res) => res.data);
}
// 270获取寻找货源一二级分类列表
export function supplyOfGoodsCate(params) {
  return axios.post("/buyer/2_1/cs/my/supplyOfGoodsCate", params).then((res) => res.data);
}
// 270获取寻找货源商品列表列表
export function supplyOfGoods(params) {
  return axios.post("/buyer/2_1/cs/my/listGoods", params).then((res) => res.data);
}
// 270推荐/取消推荐接口
export function recommendAdd(params) {
  return axios.post("/buyer/2_1/cs/recommend/add", params).then((res) => res.data);
}
// 270同城热销
export function partnerList(params) {
  return axios.post("/buyer/2_1/cs/partner/list", params).then((res) => res.data);
}
// 270获取店长个人信息的接口
export function shopInfo(params) {
  return axios.post("/buyer/2_1/cs/shopInfo", params).then((res) => res.data);
}
// 270更新店长个人信息的接口
export function updateShopInfo(params) {
  return axios.post("/buyer/2_1/cs/updateShopInfo", params).then((res) => res.data);
}
// 270图片上传接口
export function uploadImageBase64(params) {
  return axios.post("/comm/2_1/uploadImageBase64", params).then((res) => res.data);
}
// 获取收货地址列表2.2修改（刘江文）
export function getAddressList(params) {
  return axios
    .post("/member/getAddressList", params, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
    .then((res) => res.data);
}
// 270分享商品填写地址（刘江文）
export function address(params) {
  return axios.post("/buyer/2_1/cs/reservation/address", params).then((res) => res.data);
}
// 2.5.1获取视频url(玉龙)
export function playUrl(params) {
  return axios.post("/comm/2_1/live/playUrl", params).then((res) => res.data);
}
// 300 副店长列表（杨斯匀）
export function storeAssistantList(params) {
  return axios.post("/v30/cs/shop/storeAssistantList", params).then((res) => res.data);
}
// 300 移除副店长（杨斯匀）
export function removeStoreAssistant(params) {
  return axios.post("/v30/cs/shop/removeStoreAssistant", params).then((res) => res.data);
}
// 300 新增副店长（杨斯匀）
export function addStoreAssistant(params) {
  return axios.post("/v30/cs/shop/addStoreAssistant", params).then((res) => res.data);
}
// 300 获取验证码（王冬冬）
export function getVCode(params) {
  return axios.post("/v30/cs/common/getVCode", params).then((res) => res.data);
}
// 根据类型调用发送短信(2.4.3接口开始，获取短信使用的都使用这个接口)(郭伦)
export function send(params) {
  return axios.post("/comm/2_1/sms/send", params).then((res) => res.data);
}
// 280获取秒杀商品列表
export function seckillList(params) {
  return axios.post("/seller/2_1/cs/seckillList", params).then((res) => res.data);
}
// 300 获取用户平安操作错误信息公共接口（王冬冬）
export function getOperateFailMsg(params) {
  return axios.post("/v30/cs/pingan/getOperateFailMsg", params).then((res) => res.data);
}
// 280推广
export function promotion(params) {
  return axios.post("/buyer/2_1/cs/shop/products/promotion", params).then((res) => res.data);
}
// app版本更新
export function getCompareVersion(params) {
  return axios.get("/appVersion/getCompareVersion", { params }).then((res) => res.data);
}
//281 获取售后退款消息（王冬冬）
export function afterSaleMsg(params) {
  return axios.post("/buyer/2_1/cs/msg/list", params).then((res) => res.data);
}

//设置退款消息已读（王冬冬）
export function setRead(params) {
  return axios.post("/buyer/2_1/cs/msg/read", params).then((res) => res.data);
}

//获取小程序卡片的分享图
export function drawWxShare(params) {
  return axios.post("/comm/2_1/spg/drawWxShare", params).then((res) => res.data);
}

//286 邀请下单本周排行榜(杨斯匀)
export function topList(params) {
  return axios.post("/buyer/2_1/invite/top/list", params).then((res) => res.data);
}

//286我的获奖记录（杨斯匀）
export function awardRecordList(params) {
  return axios.post("/buyer/2_1/award/record/list", params).then((res) => res.data);
}

//286我的获奖记录（杨斯匀）
export function rankRecordList(params) {
  return axios.post("/buyer/2_1/invite/rank/record/list", params).then((res) => res.data);
}

//2.4.0 用户邀请详情(刘江文)
export function inviteInfo(params) {
  return axios.post("/buyer/2_1/inviteInfo", params).then((res) => res.data);
}

//300邀请记录里的查询功能（温子仪）
export function getUserByPhone(params) {
  return axios.post("/buyer/2_1/invite/getUserByPhone", params).then((res) => res.data);
}

//286设置社区店配送到家状态(杨斯匀)
export function setDeliveryState(params) {
  return axios.post("/buyer/2_1/cs/shop/setDeliveryState", params).then((res) => res.data);
}

//286获取社区店配送到家状态(杨斯匀)
export function getDeliveryState(params) {
  return axios.post("/buyer/2_1/cs/shop/getDeliveryState", params).then((res) => res.data);
}

//288获取商品推广文案信息
export function getGoodsDesc(params) {
  return axios.post("/buyer/2_1/cs/seller/getGoodsDesc", params).then((res) => res.data);
}

//288 社区店提醒卖家发货（高斯凌）
export function csPushDelivery(params) {
  return axios.post("/buyer/2_1/cs/csPushDelivery", params).then((res) => res.data);
}

//288一键提醒用户取货（高斯凌）
export function batchPushPickUpUrge(params) {
  return axios.post("/buyer/2_1/cs/batchPushPickUpUrge", params).then((res) => res.data);
}

//300 上周获奖名单列表（杨斯匀）
export function inviteRecordList(params) {
  return axios.post("/v30/cs/rank/record/listByLeastWeek", params).then((res) => res.data);
}

//300 本周销售额排行榜（杨斯匀）
export function shopTopList(params) {
  return axios.post("/v30/cs/rank/salesAmount/top/list", params).then((res) => res.data);
}

//310 （协议）获取社区店长教程(王冬冬)
export function getCsRuleContent(params) {
  return axios.post("/v30/cs/getCsRuleContent", params).then((res) => res.data);
}

//310店铺信息（商家信息）(社区|校区)(温子仪)
export function getSellerInfo(params) {
  return axios.post("/buyer/2_1/getSellerInfo", params).then((res) => res.data);
}

// 获取验证码
export function verificationCode(params) {
  return axios.get("/phone/verificationCode", { params }).then((res) => res.data);
}

// 270注册(刘江文)
export function InfoTwo(params) {
  return axios.post("/store/InfoTwo", params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }).then((res) => res.data);
}

// 320获取短信加密密钥（王冬冬）
export function getMCipher(params) {
  return axios.post("/seller/2_1/getMCipher", params).then((res) => res.data);
}

// 300厂家待截单采购单（高斯凌）
export function getWaitCutPurchaseOrder(params) {
  return axios.post("/seller/2_1/cs/getWaitCutPurchaseOrder", params).then((res) => res.data);
}

// 300（同城销售订单商品采购单）根据时间区间获取待发货商品（高斯凌）
export function getWaitDeliveryTimerProduct(params) {
  return axios.post("/seller/2_1/cs/getWaitDeliveryTimerProduct", params).then((res) => res.data);
}

// 300（同城代发订单商品采购单）根据时间区间获取待发货商品（高斯凌）
export function getAgentWaitDeliveryTimerProduct(params) {
  return axios.post("/seller/2_1/cs/getAgentWaitDeliveryTimerProduct", params).then((res) => res.data);
}

// 300（全国包邮订单商品采购单）根据时间区间获取待发货商品（高斯凌）
export function getCountryWaitDeliveryTimerProduct(params) {
  return axios.post("/seller/2_1/cs/getCountryWaitDeliveryTimerProduct", params).then((res) => res.data);
}

// 300（立即发货订单商品采购单）根据时间区间获取待发货商品（高斯凌）
export function getShipWaitDeliveryTimerProduct(params) {
  return axios.post("/seller/2_1/cs/getShipWaitDeliveryTimerProduct", params).then((res) => res.data);
}

// 310【采购单】待截单采购单（高斯凌）
export function getSchoolWaitCutPurchaseOrder(params) {
  return axios.post("/seller/2_1/v310/cs/sc/getWaitCutPurchaseOrder", params).then((res) => res.data);
}

// 310【采购单】全国包邮待发货采购单
export function getWaitDeliveryPurchaseOrder(params) {
  return axios.post("/seller/2_1/v310/cs/sc/getWaitDeliveryPurchaseOrder", params).then((res) => res.data);
}

// 310【采购单】立即送出待发货采购单
export function getSendWaitDeliveryPurchaseOrder(params) {
  return axios.post("/seller/2_1/v310/cs/sc/getSendWaitDeliveryPurchaseOrder", params).then((res) => res.data);
}

// 310校区预售-【采购单】全国包邮待发货采购单
export function getCountryPurchase(params) {
  return axios.post("/seller/2_1/v310/cs/sc/presale/getCountryPurchase", params).then((res) => res.data);
}

// 300（同城销售订单商品采购单）获取已截单待发货时间区间（高斯凌）
export function getWaitDeliveryTimer(params) {
  return axios.post("/seller/2_1/cs/getWaitDeliveryTimer", params).then((res) => res.data);
}

// 300（同城代发订单商品采购单）获取已截单待发货时间区间（高斯凌）
export function getHistoryPurchaseOrder(params) {
  return axios.post("/seller/2_1/cs/getAgentWaitDeliveryTimer", params).then((res) => res.data);
}

// 300（全国包邮订单商品采购单）获取待发货时间区间（高斯凌）
export function getCountryWaitDeliveryTimer(params) {
  return axios.post("/seller/2_1/cs/getCountryWaitDeliveryTimer", params).then((res) => res.data);
}

// 300（立即发货订单商品采购单）获取待发货时间区间（高斯凌）
export function getShipWaitDeliveryTimer(params) {
  return axios.post("/seller/2_1/cs/getShipWaitDeliveryTimer", params).then((res) => res.data);
}

// 310【采购单】全国包邮待发货采购单订单时间
export function getWaitDeliveryPurchaseTimer(params) {
  return axios.post("/seller/2_1/v310/cs/sc/getWaitDeliveryPurchaseTimer", params).then((res) => res.data);
}

// 310【采购单】立即送出待发货采购单订单时间
export function getSendWaitDeliveryPurchaseTimer(params) {
  return axios.post("/seller/2_1/v310/cs/sc/getSendWaitDeliveryPurchaseTimer", params).then((res) => res.data);
}

// 310校区预售-【采购单】全国包邮待发货采购单订单时间
export function getCountryPurchaseTimer(params) {
  return axios.post("/seller/2_1/v310/cs/sc/presale/getCountryPurchaseTimer", params).then((res) => res.data);
}

// 310注册 完善资料
export function completeInformation(params) {
  return axios.post("/store/infoCompany", params, { headers: { "Content-Type": "multipart/form-data;charset=UTF-8" } }).then((res) => res.data);
}

// 登陆two（没有审核的登录）（进入完善资料）
export function loginTwo(params) {
  return axios.post("/store/loginTwo", params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }).then((res) => res.data);
}

// 登陆two（没有审核的登录）（进入完善资料）
export function getPersonInfo(params) {
  return axios.post("/buyer/2_1/member/getPersonInfo", params).then((res) => res.data);
}

// 740首页-圈子首页-公告,类型和混批主题的内容(杨斯匀)
export function getTypeAndsw(params) {
  return axios.post("/buyer/2_1/expert/740/circle/typeAndsw", params).then((res) => res.data);
}

// 买家注销
export function deregister(params) {
  return axios.post("/buyer/2_1/deregister", params).then((res) => res.data);
}

// 320获取短信加密密钥（王冬冬）
export function getBuyerMCipher(params) {
  return axios.post("/buyer/2_1/getMCipher", params).then((res) => res.data);
}